import { Controller } from '@hotwired/stimulus';

/**
 * Opens a modal with a loading state while a Turbo form submits.
 * The Turbo Stream response replaces the content container's innerHTML,
 * which naturally replaces the loading spinner with the result.
 *
 * Usage:
 *   <div data-controller="loading-modal"
 *        data-loading-modal-modal-id-value="my-modal"
 *        data-loading-modal-content-id-value="my-content">
 *     <form data-action="submit->loading-modal#showLoading">...</form>
 *   </div>
 */
export default class extends Controller {
  static values = {
    modalId: String,
    contentId: String,
  };

  showLoading() {
    const content = document.getElementById(this.contentIdValue);
    if (content) {
      const loading = content.querySelector('[data-loading-state]');
      if (loading) loading.classList.remove('hidden');

      const result = content.querySelector('[data-result-state]');
      if (result) result.remove();
    }

    window.openModal(this.modalIdValue);
  }
}
